export enum TicketStatusType {
  Todo,
  InProgress,
  Resolved,
  Canceled,
  Pending,
  Declined,
  WaitingParts,
  Reopened,
  Submitted = 8,
  NotStarted = 9,
  Closed = 10,
}

export enum TicketStatus {
  NA = 0,
  NotReady = 1,
  InProgress = 2,
  Review = 3,
  Completed = 4,
  Canceled = 5,
}

export enum TicketCompletedStatusType {
  IsCompleted = 1,
  IsNotCompleted = 2,
}

export enum SyncWithPMSTypes {
  Yes = 'yes',
  No = 'no',
  Any = 'any',
}
